import { Button, Container, Form, Modal, Table } from "react-bootstrap"
import { IoHomeOutline } from "react-icons/io5"
import { Op_per } from "../../utils/Permissions"
import { FaPlus } from "react-icons/fa"
import DataTable from "react-data-table-component"
import { useState, useEffect } from "react"
import { DeleteAccount, GetAllAccounts } from "../../utils/proxy/AccountsProxy"
import AccountModal from "./AccountModal"
import { AiFillDelete, AiTwotoneEdit } from "react-icons/ai"
import Swal from "sweetalert2"
import { HiDotsVertical } from "react-icons/hi"
import * as XLSX from "xlsx";

export const Accounts = () => {

    const [data, setData] = useState([]);
    const [reload, setReload] = useState(false);
    const [fullscreen, setFullscreen] = useState(true);
    const [show, setShow] = useState(false);
    const [accountid, setAccountId] = useState();
    const [opttype, setOptType] = useState();

    const [showuploader, setShowUploader] = useState(false);
    const [excelData, setExcelData] = useState([]);

    const handleUploaderClose = () => {
        setShowUploader(false);
        setExcelData([]);
    }

    useEffect(() => {
        const getall = async () => {
            let d = await GetAllAccounts();
            if (d) {
                setData(d);
            } else {
                alert('Error', 'Issues while fetching data')
            }
        }
        getall()
        setReload(false);
    }, [reload])

    const handleShowCreate = () => {
        setOptType('create');
        setFullscreen(true);
        setShow(true)
    }

    function handleShow(id) {
        setOptType('update');
        setAccountId(id);
        setFullscreen(true);
        setShow(true);
    }

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();
    
        reader.onload = (event) => {
          const data = new Uint8Array(event.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const sheetData = XLSX.utils.sheet_to_json(sheet);
          setExcelData(sheetData);
        //   setFileUploaded(true);
        };
    
        file && reader.readAsArrayBuffer(file);
    };

    const handleAddData = () =>{
        if (excelData.length != 0) {
            setShowUploader(false);
            setShow(true);
            setOptType('create');
        }else{
            Swal.fire({
                title:'Info',
                text:'Excel is Empty or Some Issue With Excel',
                icon:'info'
            })
        }
    }

    const handledelete = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                let d = await DeleteAccount(id)
                if (d) {
                    setReload(true)
                    Swal.fire({
                        title: "Deleted!",
                        text: "Account has been deleted.",
                        icon: "success"
                    });
                }
            }
        });
    }

    const CustomHeader = ({ children }) => (<div style={{ backgroundColor: 'blue', padding: '10px', color: 'white' }}>    {children}  </div>);

    const columns = [
        {
            name: "Account Name",
            selector: (row) => <div onClick={() => handleShow(row.id)}><u style={{ color: 'blue', cursor: "pointer" }}>{row.accountname}</u></div>,

            // width: "12%",

            fontSize: 10,
            fontWeight: 'bold'
        },
        {
            name: "Account Type",
            selector: (row) => <div style={{ whiteSpace: 'normal', backgroundColor: row.typename === "" || row.typename === null ? "#f36e6f" : "", borderRadius: "10px", border: row.typename === "" || row.typename === null ? "2px solid transparent" : "2px solid transparent", padding: "3px", display: "flex", flexDirection: "row", color: row.typename === "" || row.typename === null ? "#fff" : "#000", margin: "3px", }}>{row.typename ? row.typename : "N/A"}</div>,

            // width: "12%",

            fontSize: 10,
            fontWeight: 'bold'
        },
        {
            name: "Industry",
            selector: (row) => <div style={{ whiteSpace: 'normal', backgroundColor: row.industryname === "" || row.industryname === null ? "#f36e6f" : "", borderRadius: "10px", border: row.industryname === "" || row.industryname === null ? "2px solid transparent" : "2px solid transparent", padding: "3px", display: "flex", flexDirection: "row", color: row.industryname === "" || row.industryname === null ? "#fff" : "#000", margin: "3px", }}>{row.industryname ? row.industryname : "N/A"}</div>,

            // width: "15%",

            fontSize: 10,
            fontWeight: 'bold'
        },
        {
            name: "Phone",
            selector: (row) => <div style={{ whiteSpace: 'normal', backgroundColor: row.phone === "" || row.phone === null ? "#f36e6f" : "", borderRadius: "10px", border: row.phone === "" || row.phone === null ? "2px solid transparent" : "2px solid transparent", padding: "3px", display: "flex", flexDirection: "row", color: row.phone === "" || row.phone === null ? "#fff" : "#000", margin: "3px", }}>{row.phone ? row.phone : "N/A"}</div>,

            // width: "15%",

            fontSize: 10,
            fontWeight: 'bold'
        },
        {
            name: "Website",
            selector: (row) => <div style={{ whiteSpace: 'normal', backgroundColor: row.website === "" || row.website === null ? "#f36e6f" : "", borderRadius: "10px", border: row.website === "" || row.website === null ? "2px solid transparent" : "2px solid transparent", padding: "3px", display: "flex", flexDirection: "row", color: row.website === "" || row.website === null ? "#fff" : "#000", margin: "3px", }}>{row.website ? row.website : "N/A"}</div>,

            // width: "15%",

            fontSize: 10,
            fontWeight: 'bold'
        },
        {
            name: "Description",
            selector: (row) => <div style={{ whiteSpace: 'normal', backgroundColor: row.description === "" || row.description === null ? "#f36e6f" : "", borderRadius: "10px", border: row.description === "" || row.description === null ? "2px solid transparent" : "2px solid transparent", padding: "3px", display: "flex", flexDirection: "row", color: row.description === "" || row.description === null ? "#fff" : "#000", margin: "3px", }}>{row.description ? row.description : "N/A"}</div>,

            // width: "15%",

            fontSize: 10,
            fontWeight: 'bold',
        },
        {
            name: "Employees",
            selector: (row) => <div style={{ whiteSpace: 'normal', backgroundColor: row.employees === "" || row.employees === null ? "#f36e6f" : "", borderRadius: "10px", border: row.employees === "" || row.employees === null ? "2px solid transparent" : "2px solid transparent", padding: "3px", display: "flex", flexDirection: "row", color: row.employees === "" || row.employees === null ? "#fff" : "#000", margin: "3px", }}>{row.employees ? row.employees : "N/A"}</div>,

            // width: "10%",

            fontSize: 10,
            fontWeight: 'bold',
        },
        {
            name: "Actions",
            selector: (row) => (
                <div key={row.id}>
                    <AiTwotoneEdit
                        style={{ color: "#9889e6", fontSize: 20, display:Op_per.get().ACCOUNTS.ALLOW_EDIT ? '' : 'none' }}
                        onClick={() => handleShow(row.id)}
                />
                &nbsp;&nbsp;&nbsp;
                    <AiFillDelete
                        onClick={() => handledelete(row.id)}
                        style={{ color: "#f36e6f", fontSize: 20, display: Op_per.get().ACCOUNTS.ALLOW_DELETE ? '' : 'none' }}
                    />
                </div>
            ),
        }
    ];

    const ExpandedComponent = ({ data }) => (
        <div style={{
            backgroundColor: data.disabled ? "#f36e6f" : "",
            color: "#fff",
            padding: 10,
            fontSize: 12,
            margin: 20,
            borderRadius: 20,
            border: "2px solid transparent",
            width: "95%"

        }}>
            <Table
                size="sm"
                className="mt-3 table table-bordered table__block"
            >
                <tr>
                    <th style={{ fontWeight: "normal", color: "#000", padding: 10, width: "10%" }} >Billing Address Street</th>
                    <td style={{ width: "10%" }}>:</td>
                    <td style={{ padding: 10, width: "30%" }}> <span style={{
                        backgroundColor: "", borderRadius: "10px", border: "2px solid transparent", padding: "5px", color: "#000", fontWeight: "normal"
                    }}>{data.billing_address_street}</span> </td>
                    <th style={{ fontWeight: "normal", color: "#000", padding: 10, width: "10%" }} >Shipping Address Street</th>
                    <td style={{ width: "10%" }}>:</td>
                    <td style={{ padding: 10, width: "30%" }}> <span style={{
                        backgroundColor: "", borderRadius: "10px", border: "2px solid transparent", padding: "5px", color: "#000", fontWeight: "normal"
                    }}>{data.shipping_address_street}</span> </td>
                </tr>

                <tr>

                    <th style={{ fontWeight: "normal", color: "#000", padding: 10, width: "10%" }}>Billing Address City</th>
                    <td style={{ width: "10%" }}>:</td>
                    <td style={{ padding: 10, width: "30%" }} > <span style={{
                        backgroundColor: data.billing_address_cityname === "" || data.billing_address_cityname === null ? "#f36e6f" : "", borderRadius: "10px", border: data.billing_address_cityname === "" || data.billing_address_cityname === null ? "2px solid transparent" : "2px solid transparent", padding: "5px", margin: "3px", color: "#000", fontWeight: "normal"
                    }}> {data.billing_address_cityname === "" || data.billing_address_cityname === null
                        ? "N/A"
                        : data.billing_address_cityname + " (" + data.billing_address_zip + ")"}</span></td>
                    <th style={{ fontWeight: "normal", color: "#000", padding: 10, width: "10%" }}>Shipping Address City</th>
                    <td style={{ width: "10%" }}>:</td>
                    <td style={{ padding: 10, width: "30%" }} > <span style={{
                        backgroundColor: data.shipping_address_cityname === "" || data.shipping_address_cityname === null ? "#f36e6f" : "", borderRadius: "10px", border: data.shipping_address_cityname === "" || data.shipping_address_cityname === null ? "2px solid transparent" : "2px solid transparent", padding: "5px", margin: "3px", color: "#000", fontWeight: "normal"
                    }}> {data.shipping_address_cityname === "" || data.shipping_address_cityname === null
                        ? "N/A"
                        : data.shipping_address_cityname + " (" + data.shipping_address_zip + ")"}</span></td>
                </tr>

                <tr>
                    <th style={{ fontWeight: "normal", color: "#000", padding: 10, width: "10%" }}>Billing Address State</th>

                    <td style={{ width: "10%" }}>:</td>
                    <td style={{ padding: 10, width: "30%" }}> <span style={{
                        backgroundColor: data.billing_address_statename === "" || data.billing_address_statename === null ? "#f36e6f" : "", borderRadius: "10px", border: data.billing_address_statename === "" || data.billing_address_statename === null ? "2px solid transparent" : "2px solid transparent", padding: "5px", margin: "3px", color: "#000", fontWeight: "normal"
                    }}> {data.billing_address_statename === "" || data.billing_address_statename === null
                        ? "N/A"
                        : data.billing_address_statename} </span></td>

                    <th style={{ fontWeight: "normal", color: "#000", padding: 10, width: "10%" }}>Shipping Address State</th>

                    <td style={{ width: "10%" }}>:</td>
                    <td style={{ padding: 10, width: "30%" }}> <span style={{
                        backgroundColor: data.shipping_address_statename === "" || data.shipping_address_statename === null ? "#f36e6f" : "", borderRadius: "10px", border: data.shipping_address_statename === "" || data.shipping_address_statename === null ? "2px solid transparent" : "2px solid transparent", padding: "5px", margin: "3px", color: "#000", fontWeight: "normal"
                    }}> {data.shipping_address_statename === "" || data.shipping_address_statename === null
                        ? "N/A"
                        : data.shipping_address_statename} </span></td>
                </tr>

                <tr>

                    <th style={{ fontWeight: "normal", color: "#000", padding: 10, width: "10%" }}>Billing Address Country </th>
                    <td style={{ width: "10%" }}>:</td>
                    <td style={{ padding: 10, width: "30%" }}> <span style={{
                        backgroundColor: data.billing_address_countryname === "" || data.billing_address_countryname === null ? "#f36e6f" : "", borderRadius: "10px", border: data.billing_address_countryname === "" || data.billing_address_countryname === null ? "2px solid transparent" : "2px solid transparent", padding: "5px", margin: "3px", color: "#000", fontWeight: "normal"
                    }}>{data.billing_address_countryname === "" || data.billing_address_countryname === null
                        ? "N/A"
                        : data.billing_address_countryname} </span></td>

                    <th style={{ fontWeight: "normal", color: "#000", padding: 10, width: "10%" }}>Shipping Address Country </th>
                    <td style={{ width: "10%" }}>:</td>
                    <td style={{ padding: 10, width: "30%" }}> <span style={{
                        backgroundColor: "#000" === "" || data.shipping_address_countryname === null ? "#f36e6f" : "", borderRadius: "10px", border: data.shipping_address_countryname === "" || data.shipping_address_countryname === null ? "2px solid transparent" : "2px solid transparent", padding: "5px", color: "#000", fontWeight: "normal"
                    }}> {data.shipping_address_countryname === "" || data.shipping_address_countryname === null ? "N/A" : data.shipping_address_countryname} </span></td>
                </tr>
            </Table>
        </div>
    );

    return (
        <Container fluid style={{ minHeight: "80vh" }}>
            <div
                className="glass-body"
                style={{
                    margin: 10,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    padding: 0,
                    backgroundColor: 'transparent'
                }}
            >

                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <ul id="breadcrumb">
                        <li><a href="/"><IoHomeOutline
                            style={{ color: "white", fontSize: 20 }}
                            
                        /></a></li>
                        <li><a href="/accounts"><span class="icon icon-beaker"> </span>Lead Management</a></li>
                        <li><a href="/accounts"><span class="icon icon-beaker"> </span>Company</a></li>
                        {/* <li><a href="#"><span class="icon icon-double-angle-right"></span>Doctor</a></li> */}

                    </ul>

                </div>
            </div>
            <div className="glass-body" style={{ margin: 10 }}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                    }}
                    className="flex-column-mobile"
                >
                    <div>
                        <Form.Control
                            className="glass"
                            placeholder="Search"
                            type="text"
                            style={{ display: 'none' }}
                        //   value={searchQuery}
                        //   onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                    <div>
                        {Op_per.get().MASTERS_HOLIDAYTYPES.ALLOW_ADD ? (
                            <div class="dropdown">
                                <button
                                class="btn btn-secondary"
                                type="button"
                                style={{ backgroundColor: "#2194f0" }}
                                title="Options"
                                id="dropdown-basic"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                >
                                <HiDotsVertical />
                                </button>
                                <ul class="dropdown-menu">
                                <li onClick={handleShowCreate}>
                                    <a class="dropdown-item">Add</a>
                                </li>
                                <li onClick={()=>setShowUploader(true)}>
                                    <a class="dropdown-item">Import XLSX</a>
                                </li>
                                </ul>
                            </div>
                        ) : ("")}
                    </div>
                </div>
                <div style={{ marginTop: 10 }}>
                    <DataTable
                        columns={columns}
                        data={data}
                        pagination
                        customStyles={{ headRow: { style: { backgroundColor: '#c0dfff', padding: 7 }, } }}
                        CustomHeader={<CustomHeader />}
                        expandableRows
                        expandableRowsComponent={ExpandedComponent}
                        style={{ marginTop: 10 }}
                        dense
                    />
                </div>
                {show ? <AccountModal fullscreen={fullscreen} show={show} setShow={setShow} accountid={accountid} setReload={setReload} opttype={opttype} excelUpload={excelData} setExcelData={setExcelData} /> : ""}

                    <Modal show={showuploader} onHide={handleUploaderClose}>
                        <Modal.Header closeButton>
                        <Modal.Title>Upload Excel</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                        <div>
                            <input
                            type="file"
                            accept=".xlsx, .xls, .csv"
                            onChange={handleFileUpload}
                            />
                        </div>
                        </Modal.Body>
                        <Modal.Footer>
                        <Button variant="secondary" onClick={handleUploaderClose}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={handleAddData}>
                            Ok
                        </Button>
                        </Modal.Footer>
                    </Modal>
            </div>
        </Container>
    )
}